/**
 * NOTE CONSTANTS
 *
 * Defines the shared maximum for standalone, schema-driven, and grid-hosted
 * CRM note text so every entry path enforces the same contract.
 */

export const NOTE_MAX_LENGTH = 65_536;
